import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 6.40039L9 12.4004L3 6.40039L4.40039 5L9 9.59961L13.5996 5L15 6.40039Z" }));
export default SvgArrowDown;
